module.exports = __webpack_public_path__ + "static/media/3793.2f253c0e.jpg";